/**
 * `Layout` — shell applicativa: navbar + area contenuti centrata.
 *
 * Le pagine di autenticazione (`/login`, `/callback`) usano una shell "plain"
 * senza navbar (non c'è ancora una sessione / navigazione utile), centrando la
 * card di stato. Le altre rotte mostrano la navbar completa.
 */
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { AigorProvider, AigorDrawer } from './AigorDrawer';

/** Rotte pubbliche di autenticazione senza navbar. */
const AUTH_ROUTES = new Set(['/login', '/callback']);

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const isAuthRoute = AUTH_ROUTES.has(location.pathname);

  if (isAuthRoute) {
    return (
      <div className="app-shell">
        <main className="app-main app-main--plain">{children}</main>
        <Footer />
      </div>
    );
  }

  // Il `AigorProvider` avvolge sia `<main>{children}</main>` (dove vivono i
  // trigger "Valuta con AIgor" per Skill, che chiamano `useAigor().open`) sia il
  // `AigorDrawer` (montato come sibling di `<main>`), così i due lati
  // condividono lo stesso contesto. Il Drawer non renderizza nulla finché
  // nessuna Skill è aperta.
  return (
    <AigorProvider>
      <div className="app-shell">
        <Navbar />
        <main className="app-main">{children}</main>
        <Footer />
        <AigorDrawer />
      </div>
    </AigorProvider>
  );
}
